import { Deserializable } from '../interfaces';

export class NivelDTO implements Deserializable {
  nivelId: string;
  nombre: string;


  constructor() {
    this.nivelId = '';
    this.nombre = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
